import { useState } from "react";
import { useConditional } from "../../core/hooks/useConditional";
import { DataContext, useDataContext } from "../../core/hooks/useData";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { FormInline } from "../../data-entry/FormModal";
import { DateCol } from "../../layout/TableCells";
import { newID } from "../../core/utils/unique";
import { SaveContext, requestSave, useSaveContext } from "../../core/hooks/useSaveContext";


export function HistoryModal(props: {
	title: string,
	cols: any[],
	items: any[],
	onClose: () => void,
}) {

	const [token, setToken] = useState("");

	const edit = useConditional((item: any) => {
		return (
			<EditModal
				item={item}
				onCancel={edit.close}
				onSave={(original: any, updated: any) => {
					debugger;
					const index = props.items.indexOf(original);
					if (index >= 0) props.items.splice(index, 1, updated);

					edit.close();
					setToken(newID());
				}}
			/>
		)
	});

	return (
		<Modal
			title={props.title}
			onCancel={props.onClose}
			showSave={false}
			cancelTitle="Close"
			size="width-50vw"
		>
			<Table
				key={token}
				cols={[
					DateCol("Effective", "effective"),
					DateCol("Ceased", "ceased"),
					...props.cols,
				]}
				items={props.items}
				interactive={true}
				onClick={(e, r) => {
					edit.show(r);
				}}
			/>

			{edit.render()}
		</Modal>
	)

}

function EditModal(props: {
	item: any,
	onCancel: () => void,
	onSave: (original: any, updated: any) => void,
}) {

	const item = {
		...props.item,
	}

	const saveContext = useSaveContext();

	return (
		<SaveContext.Provider value={saveContext}>
			<Modal
				title="Edit History Dates"
				size="width-50vw"
				onCancel={props.onCancel}
				onSave={() => {
					// check that everyone is happy with the save
					if (requestSave(saveContext.channel)) {
						props.onSave(props.item, item);
					}
				}}
			>
				<FormInline
					form="name"
					obj={item}
					options={{
						showEffective: true,
						showCeased: true,
					}}
				/>

			</Modal>
		</SaveContext.Provider>
	);
}